import React from "react";
import CardQuestionTemplate from "./components/cardQuestionTemplate/CardQuestionTemplate"
import BarQuestionTemplate from "./components/barQuestionTemplate/BarQuestionTemplate";
import TextQuestionTemplate from "./components/textQuestionTemplate/TextQuestionTemplate";
import SkinAssessmentAge from "./components/annonymous/skinAssessmentAge/SkinAssessmentAge";
import SkinAssessmentGender from "./components/annonymous/skinAssessmentGender/SkinAssessmentGender";
import { SKIN_ASSESSMENT_QUESTION_TYPES } from "../../../common/skinAssessmentConstant";

const SkinAssessmentTemplate = ({ question, sectionId, onAnswerSelect, savedAnswerIds }) => {
    let TemplateComponent = null;
    let templateProps = {};

    if (sectionId === "GENDER") {
        TemplateComponent = SkinAssessmentGender;
        templateProps = { onAnswerSelect: onAnswerSelect };
    } else if (sectionId === "AGE") {
        TemplateComponent = SkinAssessmentAge;
        templateProps = { onAnswerSelect: onAnswerSelect };
    } else if (question) {
        const { question_type } = question;

        switch (question_type) {
            case SKIN_ASSESSMENT_QUESTION_TYPES.cardSkinType:
            case SKIN_ASSESSMENT_QUESTION_TYPES.card:
                TemplateComponent = CardQuestionTemplate
                templateProps = {
                    question,
                    onAnswerSelect: onAnswerSelect,
                    savedAnswerIds: savedAnswerIds
                };
                break;

            case SKIN_ASSESSMENT_QUESTION_TYPES.bar:
                TemplateComponent = BarQuestionTemplate;
                templateProps = {
                    question,
                    onAnswerSelect: onAnswerSelect,
                    savedAnswerIds: savedAnswerIds
                };
                break;

            case SKIN_ASSESSMENT_QUESTION_TYPES.textSingle:
                TemplateComponent = TextQuestionTemplate;
                templateProps = {
                    question,
                    onAnswerSelect: onAnswerSelect,
                    savedAnswerIds: savedAnswerIds
                };
                break;

            case SKIN_ASSESSMENT_QUESTION_TYPES.textMultiple:
                TemplateComponent = TextQuestionTemplate;
                templateProps = {
                    question,
                    multiple: true,
                    onAnswerSelect: onAnswerSelect,
                    savedAnswerIds: savedAnswerIds
                };
                break;

            default:
                TemplateComponent = null;
        }
    }

    if (!TemplateComponent) return null;

    return <TemplateComponent {...templateProps} />;
};

export default SkinAssessmentTemplate;